import { NgModule } from '@angular/core'

import { SafeHtmlModule } from '../pipes/sanitize-html/safe-html.module'
import { CmsDirectivesModule } from '../directives/cms-directives.module'
import { CommonModule } from '@angular/common'
import { MbI18nModule } from '../../translations/mb-i18n.module'

@NgModule({
  imports: [
    SafeHtmlModule,
    CommonModule,
    CmsDirectivesModule,
    MbI18nModule
  ],
  exports: [
    SafeHtmlModule,
    CmsDirectivesModule,
    CommonModule
  ]
})
export class CmsComponentsBaseModule {
}
